module.exports = __webpack_public_path__ + "manualatp.pdf?9969a5bf8598f97042ab0aec1133c264";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manualatp.pdf
// module id = 112
// module chunks = 0